/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import { formatToDate } from 'utils/formatDate';
import { TableCellProps } from './types';
import { CellContainer } from './styles';

function TableCell<T>({
  column,
  row,
  rowSpan,
}: React.PropsWithChildren<TableCellProps<T>>): JSX.Element {
  const rowColumnText: React.ReactText[] = [];
  let formatRowColumnText;
  let booleanClass: 'true' | 'false' | undefined;

  if (column.cssText === undefined) {
    column.cssText = {
      paddingLeft: '8px',
    };
  }

  if (column.renderItem) {
    return (
      <CellContainer
        key={`${column.title}.${Math.random() + new Date().getTime()}`}
        style={{ ...column.cssProps }}
      >
        {/* @ts-ignore */}
        {column.renderItem(row)}
      </CellContainer>
    );
  }

  if (Array.isArray(column.props)) {
    for (let i = 0; i < column.props.length; i += 1) {
      const key = column.props[i];
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      rowColumnText.push((row as any)[key]);
    }
  } else {
    rowColumnText.push(row[column.props]);
  }

  function numberFixed(numero: number): string {
    const formattedNumber = numero.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return formattedNumber;
  }

  switch (column.type) {
    case 'number': {
      formatRowColumnText = rowColumnText.reduce((text, item, index) => {
        if (index === 0) {
          return (Math.trunc((item as number) * 100) / 100).toLocaleString(
            'pt-BR'
          );
        }
        return `${text} ${(
          Math.trunc((item as number) * 100) / 100
        ).toLocaleString('pt-BR')}`;
      }, '');
      break;
    }
    case 'currency':
      formatRowColumnText = new Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency',
      }).format(parseFloat(rowColumnText.join(' ').replace(',', '.')));
      break;
    case 'string':
      if (
        column.trunc &&
        rowColumnText.join(column.delimiter || ' ').length > column.trunc
      ) {
        formatRowColumnText = `${rowColumnText
          .join(column.delimiter || ' ')
          .slice(0, column.trunc)}...`;
      }
      break;
    case 'date':
      if (rowColumnText[0]) {
        formatRowColumnText = formatToDate({ currentDate: rowColumnText[0] });
      } else {
        formatRowColumnText = '';
      }
      break;
    case 'datetime': {
      if (rowColumnText[0]) {
        formatRowColumnText = formatToDate({
          currentDate: rowColumnText[0],
          hasMinutesAndHoursAndSecouds: true,
        });
      } else {
        formatRowColumnText = '';
      }
      break;
    }
    case 'time':
      formatRowColumnText = formatToDate({
        currentDate: rowColumnText[0],
        formatHours: true,
      });
      break;
    case 'boolean':
      if (rowColumnText.join(' ') === 'true') {
        booleanClass = 'true';
      } else {
        booleanClass = 'false';
      }
      break;
    case 'float':
      if (rowColumnText[0]) {
        formatRowColumnText = numberFixed(Number(rowColumnText[0]));
      } else {
        formatRowColumnText = '';
      }
      break;
    default:
      break;
  }

  if (column.formatter) {
    formatRowColumnText = column.formatter(row);
  }

  return (
    <>
      {column.type === 'colspan' ? (
        <CellContainer
          key={`${column.title}.${Math.random() + new Date().getTime()}`}
          boolean={booleanClass}
          stylePattern={column.type}
          positionPattern={column.position}
          style={{ ...column.cssProps }}
          rowSpan={rowSpan}
        >
          <CellContainer
            key={`${column.title}.${Math.random() + new Date().getTime()}`}
            boolean={booleanClass}
            stylePattern={column.type}
            positionPattern={column.position}
            style={{ ...column.cssProps }}
            rowSpan={rowSpan}
          >
            <div
              style={{
                padding: '8px',
                margin: 'auto',
              }}
            >
              {booleanClass &&
                (booleanClass === 'true' ? <p>Ativo</p> : <p>Inativo</p>)}
              {!booleanClass && (
                <p style={{ ...column.cssText }}>
                  {formatRowColumnText ||
                    rowColumnText.join(column.delimiter || ' ')}
                </p>
              )}
            </div>
          </CellContainer>
          <CellContainer
            key={`${column.title}.${Math.random() + new Date().getTime()}`}
            boolean={booleanClass}
            stylePattern={column.type}
            positionPattern={column.position}
            style={{ ...column.cssProps }}
            rowSpan={rowSpan}
          >
            <div
              style={{
                padding: '8px',
                margin: 'auto',
              }}
            >
              {booleanClass &&
                (booleanClass === 'true' ? <p>Ativo</p> : <p>Inativo</p>)}
              {!booleanClass && (
                <p style={{ ...column.cssText }}>
                  {formatRowColumnText ||
                    rowColumnText.join(column.delimiter || ' ')}
                </p>
              )}
            </div>
          </CellContainer>
          <CellContainer
            key={`${column.title}.${Math.random() + new Date().getTime()}`}
            boolean={booleanClass}
            stylePattern={column.type}
            positionPattern={column.position}
            style={{ ...column.cssProps }}
            rowSpan={rowSpan}
          >
            <div
              style={{
                padding: '8px',
                margin: 'auto',
              }}
            >
              {booleanClass &&
                (booleanClass === 'true' ? <p>Ativo</p> : <p>Inativo</p>)}
              {!booleanClass && (
                <p style={{ ...column.cssText }}>
                  {formatRowColumnText ||
                    rowColumnText.join(column.delimiter || ' ')}
                </p>
              )}
            </div>
          </CellContainer>
        </CellContainer>
      ) : (
        <CellContainer
          key={`${column.title}.${Math.random() + new Date().getTime()}`}
          boolean={booleanClass}
          stylePattern={column.type}
          style={{ ...column.cssProps }}
        >
          <div
            style={{
              padding: '8px',
              margin: 'auto',
            }}
          >
            {booleanClass &&
              (booleanClass === 'true' ? <p>Sim</p> : <p>Não</p>)}
            {!booleanClass && (
              <p style={{ ...column.cssText }}>
                {formatRowColumnText ||
                  rowColumnText.join(column.delimiter || ' ')}
              </p>
            )}
          </div>
        </CellContainer>
      )}
    </>
  );
}

export default TableCell;
